/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { __decorate } from "tslib";
// Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
import { customElement } from 'lit/decorators.js';
import { MenuSurfaceBase } from './mwc-menu-surface-base.js';
import { styles } from './mwc-menu-surface.css.js';
let MenuSurface = class MenuSurface extends MenuSurfaceBase {
};
MenuSurface.styles = [styles];
MenuSurface = __decorate([
    customElement('mwc-menu-surface')
], MenuSurface);
export { MenuSurface };
//# sourceMappingURL=mwc-menu-surface.js.map